import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import { useThemeStore } from './store/themeStore'
import { setupAxiosInterceptors } from './services/api'
import { fixOptimizelyCrossDomainTracking } from './utils/marketingAnalytics'

// Initialize theme on load
const initializeTheme = () => {
  const store = useThemeStore.getState()
  store.updateEffectiveTheme()
}
initializeTheme()

// Setup axios interceptors for session management
setupAxiosInterceptors()

// Carry the website's Optimizely visitor id over on every page load.
fixOptimizelyCrossDomainTracking()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error: any) => {
        // Don't retry on auth errors
        if (error?.response?.status === 401) {
          return false
        }
        return failureCount < 1
      },
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
